import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/topic-card/global.json'

export const TOPIC_CARD_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
